import { useLicenseApi } from '../api'
import styles from './footer.module.css'

export const Footer = () => {
	const license = useLicenseApi()
	return (
		<div className={styles.footer}>
			<div className={styles.footer__company_name}>АО НВП "Болид"</div>
			<div className={styles.footer__label}>{license && license.license}</div>
			<div className={styles.footer__label}>
				{license && license.serverVersion}
			</div>
		</div>
	)
}
